enum ErrorType {
	NotFound = 'NotFound',
	NotAuthorized = 'NotAuthorized',
	Forbidden = 'Forbidden',
	Other = 'Other',
}

export default ErrorType;
